import Marquee from "react-fast-marquee";

export const EditorialMarquee = () => (
  <div className="bg-ink text-paper py-6 border-y border-line-dark overflow-hidden">
    <Marquee speed={40} gradient={false} autoFill>
      {["NORTHEAST MONTANA", "FINE ART PRINTS", "ARCHIVAL PAPER", "MADE TO ORDER", "FREE SHIPPING"].map((t, i) => (
        <span key={i} className="font-serif text-4xl md:text-6xl italic mx-8 flex items-center gap-16">
          {t} <span className="text-wheat not-italic text-2xl">✳</span>
        </span>
      ))}
    </Marquee>
  </div>
);
